var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sure-order-box" },
    [
      _c(
        "Modal",
        {
          staticClass: "clearfix sure-modal",
          attrs: {
            title: _vm.titleType,
            "mask-closable": false,
            width: "1020",
            "footer-hide": ""
          },
          on: { "on-visible-change": _vm.changeState },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c("div", { staticClass: "clearfix" }, [
            _c("div", { staticClass: " formContent" }, [
              _c(
                "div",
                { staticClass: "stepTwo" },
                [
                  _vm.orderInfo.productType !== 2
                    ? _c("p", { staticClass: "littleStip" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/common/complate.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(
                          "付款后，请去【我的商标】填写商标信息\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "priceContent clearfix" },
                    [
                      _vm._l(_vm.orderInfo.clientOrderProductVOList, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "priceBox fl blue" },
                          [
                            _c("div", { staticClass: "price" }, [
                              _c("span", [_vm._v("￥")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$util.accSub(
                                      item.orderProductMoney,
                                      item.invoiceMoney
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "productName" }, [
                              _vm._v(_vm._s(item.productName))
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.payMethod !== "INTL_PAY"
                        ? _c("div", { staticClass: "priceBox fl blue" }, [
                            _c("div", { staticClass: "price" }, [
                              _c("span", [_vm._v("￥")]),
                              _vm._v(" " + _vm._s(_vm.orderInfo.invoiceMoney))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "productName" }, [
                              _vm._v("税额")
                            ])
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("PayModeCom", {
                    staticClass: "payType clearfix",
                    attrs: {
                      size: "small",
                      orderInfo: _vm.orderInfo,
                      invoiceType: _vm.invoiceType,
                      foreignInfo: _vm.foreignInfo
                    },
                    on: {
                      calculate: _vm.handleCalculate,
                      getPayMethod: function(val) {
                        return (_vm.payMethod = val)
                      },
                      getPayMode: function(val) {
                        return (_vm.payMode = val)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "payBox" },
                    [
                      _c("span", [_vm._v("应付：")]),
                      _vm._v(" "),
                      _vm.orderInfo.payMethod === "INTL_PAY"
                        ? _c("span", { staticClass: "foreign" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.currency.symbol) +
                                  " " +
                                  _vm._s(
                                    _vm.isQuota
                                      ? "--"
                                      : _vm.foreignInfo.afterAmount
                                  )
                              )
                            ]),
                            _c("em", [
                              _vm._v(
                                "¥ " +
                                  _vm._s(_vm.orderInfo.orderPaymentMoney) +
                                  " "
                              )
                            ])
                          ])
                        : _c("span", { staticClass: "local" }, [
                            _c("em", [_vm._v("¥")]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.orderInfo.orderPaymentMoney))
                            ])
                          ]),
                      _vm._v(" "),
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.goPay()
                            }
                          }
                        },
                        [_vm._v("去付款")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "coupon" },
                    [
                      _c(
                        "CheckboxGroup",
                        {
                          model: {
                            value: _vm.interest,
                            callback: function($$v) {
                              _vm.interest = $$v
                            },
                            expression: "interest"
                          }
                        },
                        [
                          _c(
                            "Checkbox",
                            { staticClass: "checkBoxs", attrs: { label: "1" } },
                            [
                              _vm.PROCESS_ENV.NODE_PLA === "kby"
                                ? [
                                    _vm._v(
                                      "\n                  同意并接受\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "blue",
                                        on: { click: _vm.checkAgreement }
                                      },
                                      [_vm._v("《服务条款》")]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.PROCESS_ENV.NODE_PLA === "wg"
                                ? [
                                    _vm._v(
                                      "\n                  同意并接受\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "blue",
                                        on: { click: _vm.checkAgreement }
                                      },
                                      [_vm._v("《盛骁科技用户协议》")]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "tips" }, [
                    _vm._v(
                      "汇率实时更新，请尽快支付，付款时会以最新汇率进行换算"
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("PayTipsComponent", {
            staticStyle: {
              position: "relative",
              left: "-16px",
              width: "1023px",
              bottom: "-3px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showUser
        ? _c("userAgreement", {
            on: {
              changeState: function($event) {
                _vm.showUser = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showIntlOffline
        ? _c("IntlOfflinePay", {
            attrs: { visible: _vm.showIntlOffline, payInfo: _vm.payInfo },
            on: {
              "update:visible": function($event) {
                _vm.showIntlOffline = $event
              },
              cancel: function($event) {
                _vm.showIntlOffline = false
              },
              ok: _vm.handleOfflineOk
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showIntlVisible
        ? _c("IntlPay", {
            attrs: { visible: _vm.showIntlVisible, payParams: _vm.payParams },
            on: {
              "update:visible": function($event) {
                _vm.showIntlVisible = $event
              },
              cancel: _vm.handleCancelIntlPay,
              ok: _vm.handleConfirmIntlPay
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4b9eaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a4b9eaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/sureOrder.vue
// module id = null
// module chunks = 